import { call, takeLatest, fork, put } from 'redux-saga/effects';
import { requestFarmDetails } from '../requesters/farmRequester';
import { REQUEST_FARM_DETAILS } from '../constants/actionTypes';
import { logDmbErrorLocation } from '../utils/error';
import { receiveFarmDetails, farmDetailsFailure } from '../actions/farmActions';

/**
 * Calls the requester to get farm details
 * @param {Object} action
 * @param {String} action.farmUuid
 * @return {Object}
 */
export function* getFarmDetails(action) {
  try {
    const response = yield call(requestFarmDetails, action.farmUuid);
    yield put(receiveFarmDetails(response));
  } catch (error) {
    logDmbErrorLocation(error, 'farm saga');
    yield put(farmDetailsFailure());
  }
}

export function* getFarmDetailsWatcher() {
  yield takeLatest(REQUEST_FARM_DETAILS, getFarmDetails);
}

/**
 * Uses fork to start multiple watchers in parallel
 * @return {void}
 */
export default function* rootSaga() {
  yield fork(getFarmDetailsWatcher);
}
